import definitions from '../../data/visitorEmotes.json';
import type { components } from './api.generated';
import type { CitizenAsset } from '../world/life/citizens/citizenAsset';
import type { InputFrame } from '../controls/types';

export const EMOTES = definitions;
export type EmoteName = keyof typeof definitions;
export type Gesture = components['schemas']['Gesture'];

export function emoteAvailable(name: EmoteName, character: 'male' | 'female'): boolean {
  return !EMOTES[name].hat || character === 'male';
}

export function emoteCommand(text: string): EmoteName | null {
  const name = text.trim().toLowerCase().slice(1);
  return text.trim().startsWith('/') && Object.hasOwn(EMOTES, name) ? (name as EmoteName) : null;
}

export function activeGesture(
  gesture: Gesture | null | undefined,
  epochMs: number
): Gesture | null {
  return gesture && epochMs < gesture.started_at_ms + gesture.duration_ms ? gesture : null;
}

export function gestureInput(frame: InputFrame, active: boolean): InputFrame {
  return active
    ? { ...frame, forward: 0, right: 0, turn: 0, up: 0, boost: false, actions: [] }
    : frame;
}

export function gesturePose(
  asset: CitizenAsset,
  gesture: Gesture | null | undefined,
  epochMs: number,
  candle = false
) {
  const current = activeGesture(gesture, epochMs);
  if (!current) return null;
  const name = `${EMOTES[current.name].clip}${candle ? 'Candle' : ''}`;
  const clip = asset.clips[name];
  if (!clip) throw new Error(`Missing citizen gesture clip: ${name}`);
  const elapsed = Math.max(0, epochMs - current.started_at_ms);
  const phase = Math.min(0.999999, elapsed / current.duration_ms);
  const edge = Math.max(0, Math.min(1, elapsed / 120, (current.duration_ms - elapsed) / 120));
  return { name, phase, row: clip.row + phase * clip.rows, mix: edge * edge * (3 - 2 * edge) };
}
